import React from 'react'
import styles from './styles.module.css';

const Item = ({name,image,stars,reviewAvg}) => {
    return (
        <div>
            <div className={styles.exploreItem}>
                <div className={styles.Img}>
                    <img src={image} width={"100%"} alt="hotelImg" />
                </div>
                <div className={styles.hotelName}>
                    {name}
                </div>
                <div className={styles.reviews}>
                    <p className={styles.star}>{stars}</p>
                    <p className={styles.starAvg}>{reviewAvg}</p>
                </div>
            </div>
        </div>
    )
}

export default Item
